import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import axiosInstance from 'src/utils/axios';

export interface ExternalCatalogResponse {
  redirectUrl: string;
  statusCode: number;
  statusText: string;
  showPunchoutOrderGuide: boolean;
  supplierStatusCode?: number;
}

async function fetchExternalCatalog(catalogId: number): Promise<ExternalCatalogResponse> {
  const res = await axiosInstance.get<ExternalCatalogResponse>(api.getExternalCatalogs(catalogId));
  return res.data;
}

const useGetExternalCatalogMutation = () =>
  useMutation({
    mutationFn: (catalogId: number) => fetchExternalCatalog(catalogId),
  });

export default useGetExternalCatalogMutation;
